import { useState } from "react";

export default function LoginView({ onLogin }) {
  const [pw, setPw]   = useState("");
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErr(false);
    try {
      const r = await fetch("/api/auth", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password: pw }),
      });
      const data = await r.json();
      if (data.token) {
        localStorage.setItem("cs_token", data.token);
        onLogin();
      } else {
        setErr(true);
      }
    } catch {
      setErr(true);
    }
    setLoading(false);
  };

  return (
    <div style={{
      minHeight: "100vh", background: "#0D0F14",
      display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{ width: 320, textAlign: "center" }}>
        <div style={{ fontSize: 22, fontWeight: 700, fontFamily: "'Syne',sans-serif",
                      color: "#00E5C0", letterSpacing: 4, marginBottom: 40 }}>
          CRYPTOSCAN
        </div>
        <form onSubmit={submit}>
          <input
            type="password"
            value={pw}
            onChange={e => setPw(e.target.value)}
            placeholder="Mot de passe"
            style={{
              width: "100%", boxSizing: "border-box",
              background: "#0D1117", border: `1px solid ${err ? "#E03030" : "#1C2030"}`,
              borderRadius: 6, padding: "12px 16px", color: "#E0E4F0",
              fontSize: 13, fontFamily: "'IBM Plex Mono',monospace",
              outline: "none", marginBottom: 12,
            }}
          />
          {err && (
            <div style={{ fontSize: 10, color: "#E03030", marginBottom: 12 }}>
              Mot de passe incorrect
            </div>
          )}
          <button type="submit" disabled={loading || !pw} style={{
            width: "100%", padding: "12px", borderRadius: 6,
            background: "#00E5C0", color: "#0D0F14", border: "none",
            fontSize: 11, fontWeight: 700, fontFamily: "'IBM Plex Mono',monospace",
            letterSpacing: 2, cursor: loading ? "wait" : "pointer",
            opacity: (!pw || loading) ? 0.5 : 1,
          }}>
            {loading ? "..." : "CONNEXION"}
          </button>
        </form>
      </div>
    </div>
  );
}
